/**
 * Character Behaviors Index
 * 
 * Registers all character configs as behaviors.
 */

export { 
  registerCharacterBehavior, 
  getCharacterConfig,
  hasCharacterBehavior,
  type CharacterConfigBehavior 
} from './register';

// Import character configs
import { LILLY_CONFIG } from '../../../config/characters/lilly';
import { DANIEL_CONFIG } from '../../../config/characters/daniel';
import { HOTDOG_CONFIG } from '../../../config/characters/hotdog';
import { ZOMBIE_CONFIG } from '../../../config/characters/zombie';
import { registerCharacterBehavior } from './register';

/**
 * Register all built-in character behaviors.
 * Call this at application startup.
 */
export function registerCharacterBehaviors(): void {
  registerCharacterBehavior(LILLY_CONFIG);
  registerCharacterBehavior(DANIEL_CONFIG);
  registerCharacterBehavior(HOTDOG_CONFIG);
  registerCharacterBehavior(ZOMBIE_CONFIG);
}
